export const messages = {
  ar: {
    brand: "بلدي Market",
    brandMarket: "بلدي Market",
    ourStory: "قصتنا",
    shopNow: "تسوق الآن",
    admin: "لوحة الإدارة",
    adminLogin: "تسجيل دخول المدير",
    logout: "تسجيل الخروج",
    heroEyebrow: "قالب تجارة إلكترونية",
    heroTitle: "عسل طبيعي لمطابخ عصرية.",
    heroLede:
      "ابنِ الثقة فوراً مع بطل غني بالتجربة وبطاقات منتجات قوية وأقسام تحكي القصة. استبدل النص وأطلق متجرك اليوم.",
    heroBrowse: "تصفح المنتجات",
    heroHow: "طريقة الحصاد",
    statDelivery: "48 ساعة",
    statDeliveryTxt: "توصيل وطني",
    statRating: "4.9★",
    statRatingTxt: "من 8400 عميل",
    statCo2: "محايد كربونياً",
    statCo2Txt: "التغليف + الشحن",
    heroCardTag: "حصاد محدود",
    heroCardTitle: "عسل الغابة",
    heroCardDesc:
      "ملمس حريري ونكهات زهرية مع لمسات صنوبر ومشمش. معصور على دفعات صغيرة.",
    priceInStock: "متوفر",
    addToCart: "أضف إلى السلة",
    highlight1Title: "حصاد أحادي المصدر",
    highlight1Txt:
      "كل دفعة مرتبطة بحقل وتاريخ محدد، لتعرف دائماً قصة البرطمان.",
    highlight2Title: "زجاج وليس بلاستيك",
    highlight2Txt:
      "جرار زجاجية تحمي النكهات من الأشعة وتبدو رائعة على طاولتك.",
    highlight3Title: "توصيل خلال يومين",
    highlight3Txt:
      "عسل طازج يعصر أسبوعياً ويصل في تغليف قابل لإعادة التدوير.",
    learnMore: "اعرف المزيد →",
    storyEyebrow: "تتبع شفاف",
    storyTitle: "من الخلية إلى البرطمان، كل خطوة قابلة للتتبع.",
    storyLede:
      "يعرض القالب مهمتك وأرقامك بوضوح: شهادات المختبر، خرائط المنشأ، ووعود الاستدامة دون التضحية بالتحويل.",
    pillCold: "مصفّى بارداً",
    pillColdTxt: "دون تسخين مفرط للحفاظ على الإنزيمات.",
    pillLab: "مختبر معتمد",
    pillLabTxt: "شهادات خلو من المبيدات والمضادات لكل دفعة.",
    pillBee: "النحل أولاً",
    pillBeeTxt: "10٪ من الأرباح تعاد لاستصلاح موائل الملقحات.",
    productsTitle: "منتجاتنا",
    productsLede:
      "اكتشف أفضل عروض العسل الطبيعي بنسبة 100٪ والمعبأ مباشرة من خلايانا.",
    productsLoading: "جارٍ تحميل المنتجات...",
    productsError: "تعذّر تحميل المنتجات",
    ctaEyebrow: "جاهز للولاء",
    ctaTitle: "أطلق النشرات وعمليات إعادة الطلب بسهولة.",
    ctaLede:
      "التقط البريد، أعلن عن الإصدارات المحدودة، وأبقِ العملاء يعودون بمكونات React بسيطة.",
    ctaPlaceholder: "أدخل بريدك الإلكتروني",
    ctaButton: "أعلمني",
    ctaFootnote: "لا رسائل مزعجة. فقط إصدارات موسمية ووصفات.",
    testimonialsTitle: "آراء عملائنا",
    testimonial1: "عسل رائع! النكهة طبيعية والجودة عالية. سأطلب مرة أخرى بالتأكيد.",
    testimonial2: "خدمة توصيل سريعة ومنتج ممتاز. أحب كيف يدعمون النحل.",
    testimonial3: "أفضل عسل جربتُه. نقي وطازج. شكراً لـ Beldi Market!",
    testimonial4: "منتجات عالية الجودة وتجربة تسوق رائعة. موصى به بشدة.",
    footerShop: "المتجر",
    footerQuick: "روابط سريعة",
    footerAbout: "عن BeldiMarket",
    footerCopy: "جميع الحقوق محفوظة",
    aboutTitle: "عن BeldiMarket",
    aboutTxt1:
      "بدأت رحلتنا بشغف للعسل النقي والتزام بتربية النحل المستدامة.",
    aboutTxt2:
      "نؤمن أن أفضل المنتجات تأتي من نحل صحي وبيئة مزدهرة، لذا نعطي الأولوية للمعاملة الأخلاقية للنحل وطرق الحصاد الصديقة للبيئة.",
    aboutExplore: "تصفح المنتجات",
    productsPageTitle: "منتجاتنا",
    productsPageIntro:
      "اكتشف تشكيلتنا من العسل العضوي النقي، المصنوعة بعناية لتقديم أفضل ما في الطبيعة.",
    blogTitle: "مدونتنا",
    blogIntro:
      "ابقَ على اطلاع بآخر الأخبار والنصائح والقصص حول تربية النحل والعسل والحياة المستدامة.",
    contactTitle: "اتصل بنا",
    contactIntro:
      "يسعدنا سماعك! سواءً كانت لديك أسئلة عن منتجاتنا أو تربية النحل أو تريد إلقاء التحية، تواصل معنا.",
    contactEmail: "البريد الإلكتروني",
    contactPhone: "الهاتف",
    contactAddress: "العنوان",
    contactFormTitle: "أرسل رسالة",
    contactName: "الاسم",
    contactSubject: "الموضوع",
    contactMessage: "الرسالة",
    contactSend: "إرسال",
    adminUsers: "إدارة المستخدمين",
    name: "الاسم",
    description: "الوصف",
    parentCategory: "الفئة الرئيسية",
    categoryImage: "صورة الفئة",
    none: "بدون",
    actions: "إجراءات",
    list: "القائمة",
    edit: "تعديل",
    delete: "حذف",
    create: "إنشاء",
    save: "حفظ",
    cancel: "إلغاء",
    loading: "جارٍ التحميل...",
    confirmDelete: "هل أنت متأكد من الحذف؟",
    adminCrudHint: "هذه البيانات تأتي مباشرة من قاعدة البيانات عبر API.",
    price: "السعر",
    originalPrice: "السعر قبل الخصم",
    stock: "المخزون",
    category: "الفئة",
    active: "مفعل",
    inactive: "غير مفعل",
	    imageLarge: "صورة كبيرة",
	    imageSmall: "صورة صغيرة",
	    cropImage: "قص الصورة",
	    cropHint: "حرّك الصورة بإصبعك/الماوس لتحديد الإطار.",
	    cropZoom: "تكبير",
	    cropCancel: "إلغاء",
	    cropApply: "تطبيق",
	    cropReset: "إعادة ضبط",
	    cropLargeTitle: "قص الصورة الكبيرة",
	    cropSmallTitle: "قص الصورة الصغيرة",
	    cropCategoryTitle: "قص صورة الفئة",
	    imageLargeRequired: "المرجو إضافة صورة كبيرة للمنتج.",
	    imageSmallRequired: "المرجو إضافة صورة صغيرة للمنتج.",
	    categoryImageRequired: "المرجو إضافة صورة للفئة.",
	    role: "الدور",
	    publishedAt: "تاريخ النشر",
	    optional: "اختياري",
	    cart: "السلة",
    continueShopping: "متابعة التسوق",
    clearCart: "تفريغ السلة",
    cartEmpty: "سلتك فارغة.",
    browseProducts: "تصفح المنتجات",
    remove: "إزالة",
    summary: "الملخص",
    items: "العناصر",
    total: "الإجمالي",
    loginToCheckout: "سجل الدخول لإتمام الشراء",
    checkout: "الدفع",
    cartNote: "سيتم حفظ سلتك في حسابك بعد تسجيل الدخول.",
    noDescription: "لا يوجد وصف لهذا المنتج.",
    inStock: "متوفر",
    outOfStock: "غير متوفر",
    goToCart: "اذهب إلى السلة",
    adminTitle: "لوحة الإدارة",
    adminIntro: "إدارة التطبيق من واجهة التحكم.",
	    adminDashboard: "لوحة التحكم",
	    adminCategories: "إدارة الفئات",
	    adminProducts: "إدارة المنتجات",
	    adminOrders: "إدارة الطلبات",
	    adminSettings: "الإعدادات",
	    dashboardTitle: "لوحة التحكم",
	    dashboardIntro: "نظرة عامة على التطبيق",
	    orders: "الطلبات",
	    totalOrders: "إجمالي الطلبات",
	    ordersLast7Days: "الطلبات (آخر 7 أيام)",
	    quickActions: "إجراءات سريعة",
	    manageOrders: "إدارة الطلبات",
	    adminOrdersIntro: "تتبع طلبات العملاء وتغيير الحالة.",
	    filterStatus: "تصفية حسب الحالة",
	    refresh: "تحديث",
	    all: "الكل",
	    selectAll: "تحديد الكل",
	    select: "تحديد",
	    exportExcel: "تصدير Excel",
	    comment: "تعليق",
	    commentPlaceholder: "أضف تعليقاً...",
	    orderId: "رقم الطلب",
	    client: "العميل",
	    createdAt: "تاريخ الإنشاء",
	    status: "الحالة",
	    viewDetails: "عرض التفاصيل",
	    product: "منتج",
	    orderStatusOrdered: "تم الطلب",
	    orderStatusProcessing: "قيد المعالجة",
	    orderStatusShipped: "تم الشحن",
	    orderStatusDelivered: "تم التسليم",
	    orderStatusCanceled: "ملغي",
	    adminStatsCategories: "فئات",
	    adminStatsProducts: "منتجات",
	    adminStatsOrders: "طلبات",
    adminStatsUsers: "مستخدمون",
    adminManageProducts: "إدارة المنتجات",
    adminManageCategories: "إدارة الفئات",
    loginTitle: "تسجيل دخول المدير",
    loginSubtitle: "خاص بحسابات الإدارة. يلزم توكن صالح لعمليات CRUD.",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    loginBtn: "تسجيل الدخول",
    checkingSession: "جاري التحقق من الجلسة...",
    langAr: "العربية",
    langEn: "English",
    langFr: "Français",
    navHome: "الرئيسية",
    navBrand: "علامتنا",
    navAbout: "من نحن",
    navProducts: "المنتجات",
    navBlog: "المدونة",
    navContact: "اتصل بنا",
    categories: "الفئات",
    allCategories: "كل المنتجات",
    subcategories: "الفئات الفرعية",
    allSubcategories: "الكل",
    filters: "فلاتر",
    min: "الحد الأدنى",
    max: "الحد الأقصى",
    resetFilters: "إعادة تعيين",
    productsEmpty: "لا توجد منتجات في هذه الفئة.",
    email: "البريد الإلكتروني",
    authEyebrow: "حساب",
    authLoginTab: "تسجيل الدخول",
    authRegisterTab: "إنشاء حساب",
    authLoginTitle: "تسجيل الدخول",
    authLoginSubtitle: "إذا كان حسابك Admin سيتم توجيهك تلقائياً للوحة الإدارة.",
    authRegisterTitle: "إنشاء حساب عميل",
    authRegisterSubtitle: "أنشئ حساباً لحفظ الطلبات وتسهيل الشراء.",
    registerBtn: "إنشاء حساب",
    haveAccount: "لديك حساب؟",
    goLogin: "تسجيل الدخول",
    noAccount: "ليس لديك حساب؟",
    goRegister: "إنشاء حساب",
    backToShop: "العودة للمتجر",
    authError: "حدث خطأ، حاول مرة أخرى.",
  },
  en: {
    brand: "BeldiMarket",
    brandMarket: "BeldiMarket",
    ourStory: "Our Story",
    shopNow: "Shop Now",
    admin: "Admin",
    adminLogin: "Admin Login",
    logout: "Logout",
    heroEyebrow: "Taste-forward e-commerce template",
    heroTitle: "Nature-crafted honey for modern kitchens.",
    heroLede:
      "Build trust instantly with an experiential hero, rich product cards, and story-driven sections. Swap our copy with yours and launch today.",
    heroBrowse: "Browse products",
    heroHow: "See how we harvest",
    statDelivery: "48h",
    statDeliveryTxt: "Nationwide delivery",
    statRating: "4.9★",
    statRatingTxt: "From 8,400 customers",
    statCo2: "CO₂ neutral",
    statCo2Txt: "Packaging + shipping",
    heroCardTag: "Limited harvest",
    heroCardTitle: "Forest Bloom Reserve",
    heroCardDesc:
      "Silky, floral, with notes of pine and apricot. Spun in small batches.",
    priceInStock: "In stock",
    addToCart: "Add to cart",
    highlight1Title: "Single-origin harvests",
    highlight1Txt:
      "Every batch is traced to a specific field and date, so you always know the story behind the jar.",
    highlight2Title: "Glass, never plastic",
    highlight2Txt:
      "Premium UV-protected jars that keep flavors intact and look great on your counter.",
    highlight3Title: "2-day delivery",
    highlight3Txt:
      "Freshly spun honey, bottled weekly, delivered in recyclable packaging.",
    learnMore: "Learn more →",
    storyEyebrow: "Transparent sourcing",
    storyTitle: "From hive to jar, every step is traceable.",
    storyLede:
      "Keep mission and metrics upfront: lab results, origin maps, and sustainability promises without hurting conversions.",
    pillCold: "Cold-filtered",
    pillColdTxt: "No overheating, enzymes stay alive.",
    pillLab: "Lab tested",
    pillLabTxt: "Pesticide & antibiotic free certificates for every lot.",
    pillBee: "Bee first",
    pillBeeTxt: "10% of profits reinvested in pollinator habitats.",
    productsTitle: "Our products",
    productsLede:
      "Discover our best natural honey offers, 100% pure and packed from our hives.",
    productsLoading: "Loading products...",
    productsError: "Failed to load products",
    ctaEyebrow: "Loyalty-ready",
    ctaTitle: "Launch with newsletter and reorder bar built-in.",
    ctaLede:
      "Capture emails, drop limited releases, and keep customers returning with simple React components.",
    ctaPlaceholder: "Enter your email",
    ctaButton: "Notify me",
    ctaFootnote: "No spam. Just seasonal drops and recipes.",
    testimonialsTitle: "Customer Reviews",
    testimonial1: "Amazing honey! The flavor is natural and the quality is top-notch. Will definitely order again.",
    testimonial2: "Fast delivery service and excellent product. I love how they support bees.",
    testimonial3: "Best honey I've ever tried. Pure and fresh. Thanks Beldi Market!",
    testimonial4: "High-quality products and great shopping experience. Highly recommended.",
    footerShop: "Shop",
    footerQuick: "Quick links",
    footerAbout: "About BeldiMarket",
    footerCopy: "All rights reserved",
    aboutTitle: "About BeldiMarket",
    aboutTxt1:
      "Our journey began with a passion for pure honey and a commitment to sustainable beekeeping.",
    aboutTxt2:
      "We believe the best products come from healthy bees and thriving ecosystems, so we prioritize ethical treatment and eco-friendly harvesting.",
    aboutExplore: "Explore our products",
    productsPageTitle: "Our Products",
    productsPageIntro:
      "Discover our range of pure, organic honey products, crafted to bring you the best of nature.",
    blogTitle: "Our Blog",
    blogIntro:
      "Stay updated with the latest news, tips, and stories about beekeeping, honey, and sustainable living.",
    contactTitle: "Contact Us",
    contactIntro:
      "We'd love to hear from you! Questions about our products or beekeeping? Say hello.",
    contactEmail: "Email",
    contactPhone: "Phone",
    contactAddress: "Address",
    contactFormTitle: "Send us a message",
    contactName: "Name",
    contactSubject: "Subject",
    contactMessage: "Message",
    contactSend: "Send",
    adminUsers: "Manage users",
    name: "Name",
    description: "Description",
    parentCategory: "Parent category",
    categoryImage: "Category image",
    none: "None",
    actions: "Actions",
    list: "List",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
    loading: "Loading...",
    confirmDelete: "Are you sure you want to delete?",
    adminCrudHint: "This data comes from the database via the API.",
    price: "Price",
    originalPrice: "Original price",
    stock: "Stock",
    category: "Category",
    active: "Active",
    inactive: "Inactive",
	    imageLarge: "Large image",
	    imageSmall: "Small image",
	    cropImage: "Crop image",
	    cropHint: "Drag the image to frame it.",
	    cropZoom: "Zoom",
	    cropCancel: "Cancel",
	    cropApply: "Apply",
	    cropReset: "Reset",
	    cropLargeTitle: "Crop large image",
	    cropSmallTitle: "Crop small image",
	    cropCategoryTitle: "Crop category image",
	    imageLargeRequired: "Please add a large product image.",
	    imageSmallRequired: "Please add a small product image.",
	    categoryImageRequired: "Please add a category image.",
	    role: "Role",
	    publishedAt: "Published at",
	    optional: "Optional",
	    cart: "Cart",
    continueShopping: "Continue shopping",
    clearCart: "Clear cart",
    cartEmpty: "Your cart is empty.",
    browseProducts: "Browse products",
    remove: "Remove",
    summary: "Summary",
    items: "Items",
    total: "Total",
    loginToCheckout: "Log in to checkout",
    checkout: "Checkout",
    cartNote: "Your cart will be saved to your account after login.",
    noDescription: "No description for this product.",
    inStock: "In stock",
    outOfStock: "Out of stock",
    goToCart: "Go to cart",
    adminTitle: "Admin Panel",
    adminIntro: "Manage the app from this admin interface.",
	    adminDashboard: "Dashboard",
	    adminCategories: "Manage categories",
	    adminProducts: "Manage products",
	    adminOrders: "Manage orders",
	    adminSettings: "Settings",
	    dashboardTitle: "Dashboard",
	    dashboardIntro: "Overview of your BeldiMarket app",
	    orders: "Orders",
	    totalOrders: "Total orders",
	    ordersLast7Days: "Orders (last 7 days)",
	    quickActions: "Quick actions",
	    manageOrders: "Manage orders",
	    adminOrdersIntro: "Track customer orders and update their status.",
	    filterStatus: "Filter by status",
	    refresh: "Refresh",
	    all: "All",
	    selectAll: "Select all",
	    select: "Select",
	    exportExcel: "Export (Excel)",
	    comment: "Comment",
	    commentPlaceholder: "Add a comment...",
	    orderId: "Order ID",
	    client: "Client",
	    createdAt: "Created at",
	    status: "Status",
	    viewDetails: "View details",
	    product: "Product",
	    orderStatusOrdered: "Ordered",
	    orderStatusProcessing: "Processing",
	    orderStatusShipped: "Shipped",
	    orderStatusDelivered: "Delivered",
	    orderStatusCanceled: "Canceled",
	    adminStatsCategories: "Categories",
	    adminStatsProducts: "Products",
	    adminStatsOrders: "Orders",
    adminStatsUsers: "Users",
    adminManageProducts: "Manage products",
    adminManageCategories: "Manage categories",
    loginTitle: "Admin login",
    loginSubtitle:
      "Reserved for admin accounts. CRUD (categories, products, users) requires a valid token.",
    username: "Username",
    password: "Password",
    loginBtn: "Log in",
    checkingSession: "Checking session...",
    clientLogin: "Client Login",
    clientLoginTitle: "Log in to your account",
    clientLoginSubtitle: "Track orders and reorder faster.",
    clientRegister: "Create account",
    clientRegisterTitle: "Create your customer account",
    clientRegisterSubtitle: "Save favorites, orders, and faster checkout.",
    registerBtn: "Create account",
    haveAccount: "Already have an account?",
    goLogin: "Log in",
    noAccount: "No account?",
    goRegister: "Create one",
    registerBtnShort: "Register",
    navHome: "Home",
    navBrand: "Our Brand",
    navAbout: "About",
    navProducts: "Products",
    navBlog: "Blog",
    navContact: "Contact",
    categories: "Categories",
    allCategories: "All products",
    subcategories: "Subcategories",
    allSubcategories: "All",
    filters: "Filters",
    min: "Min",
    max: "Max",
    resetFilters: "Reset",
    productsEmpty: "No products in this category.",
    email: "Email",
    authEyebrow: "Account",
    authLoginTab: "Log in",
    authRegisterTab: "Register",
    authLoginTitle: "Log in",
    authLoginSubtitle: "If your account is Admin, you will be redirected to the admin dashboard.",
    authRegisterTitle: "Create a customer account",
    authRegisterSubtitle: "Create an account to save orders and checkout faster.",
    backToShop: "Back to shop",
    authError: "Something went wrong. Try again.",
    langAr: "العربية",
    langEn: "English",
    langFr: "Français",
  },
  fr: {
    brand: "BeldiMarket",
    brandMarket: "BeldiMarket",
    ourStory: "Notre histoire",
    shopNow: "Boutique",
    admin: "Admin",
    adminLogin: "Connexion admin",
    logout: "Déconnexion",
    heroEyebrow: "Template e-commerce",
    heroTitle: "Un miel naturel pour des cuisines modernes.",
    heroLede:
      "Gagnez la confiance instantanément avec un hero immersif, des cartes produits riches et des sections qui racontent votre histoire.",
    heroBrowse: "Voir les produits",
    heroHow: "Notre récolte",
    statDelivery: "48h",
    statDeliveryTxt: "Livraison nationale",
    statRating: "4.9★",
    statRatingTxt: "Sur 8 400 clients",
    statCo2: "Neutre CO₂",
    statCo2Txt: "Emballage + expédition",
    heroCardTag: "Récolte limitée",
    heroCardTitle: "Réserve Forêt",
    heroCardDesc:
      "Texture soyeuse, notes florales et d'abricot. Filtré en petites séries.",
    priceInStock: "En stock",
    addToCart: "Ajouter au panier",
    highlight1Title: "Récoltes mono-origine",
    highlight1Txt:
      "Chaque lot est tracé à un champ et une date, vous connaissez l'histoire du pot.",
    highlight2Title: "Verre, jamais plastique",
    highlight2Txt:
      "Bocaux anti-UV premium qui préservent les arômes et embellissent le plan de travail.",
    highlight3Title: "Livraison 2 jours",
    highlight3Txt:
      "Miel fraîchement extrait chaque semaine, livré en emballage recyclable.",
    learnMore: "En savoir plus →",
    storyEyebrow: "Traçabilité claire",
    storyTitle: "De la ruche au pot, chaque étape est suivie.",
    storyLede:
      "Affichez mission et indicateurs : analyses labo, origines et engagements durables sans sacrifier la conversion.",
    pillCold: "Filtré à froid",
    pillColdTxt: "Pas de surchauffe, les enzymes restent actives.",
    pillLab: "Testé en labo",
    pillLabTxt: "Certificats sans pesticides ni antibiotiques pour chaque lot.",
    pillBee: "Les abeilles d'abord",
    pillBeeTxt: "10 % des profits réinvestis dans les habitats pollinisateurs.",
    productsTitle: "Nos produits",
    productsLede:
      "Découvrez nos meilleures offres de miel naturel à 100 %, directement de nos ruches.",
    productsLoading: "Chargement des produits...",
    productsError: "Erreur de chargement des produits",
    ctaEyebrow: "Prêt pour la fidélité",
    ctaTitle: "Lancez newsletter et réassort intégré.",
    ctaLede:
      "Capturez les emails, sortez des séries limitées et faites revenir vos clients avec quelques composants React.",
    ctaPlaceholder: "Votre email",
    ctaButton: "Prévenez-moi",
    ctaFootnote: "Pas de spam. Des sorties saisonnières et des recettes.",
    footerShop: "Boutique",
    footerQuick: "Liens rapides",
    footerAbout: "À propos de BeldiMarket",
    footerCopy: "Tous droits réservés",
    aboutTitle: "À propos de BeldiMarket",
    aboutTxt1:
      "Notre aventure est née d'une passion pour le miel pur et l'apiculture durable.",
    aboutTxt2:
      "Nous croyons que les meilleurs produits viennent d'abeilles en bonne santé et d'écosystèmes florissants; priorité au respect des abeilles et à la récolte éthique.",
    aboutExplore: "Découvrir nos produits",
    productsPageTitle: "Nos produits",
    productsPageIntro:
      "Une gamme de miels bio et purs, élaborés pour offrir le meilleur de la nature.",
    blogTitle: "Notre blog",
    blogIntro:
      "Actus, conseils et histoires sur l'apiculture, le miel et la vie durable.",
    contactTitle: "Contactez-nous",
    contactIntro:
      "Questions sur nos produits ou l'apiculture ? Écrivez-nous, nous répondons vite.",
    contactEmail: "Email",
    contactPhone: "Téléphone",
    contactAddress: "Adresse",
    contactFormTitle: "Envoyez-nous un message",
    contactName: "Nom",
    contactSubject: "Sujet",
    contactMessage: "Message",
    contactSend: "Envoyer",
    adminUsers: "Gérer les utilisateurs",
    name: "Nom",
    description: "Description",
    parentCategory: "Catégorie parente",
    categoryImage: "Image de catégorie",
    none: "Aucune",
    actions: "Actions",
    list: "Liste",
    edit: "Modifier",
    delete: "Supprimer",
    create: "Créer",
    save: "Enregistrer",
    cancel: "Annuler",
    loading: "Chargement...",
    confirmDelete: "Confirmer la suppression ?",
    adminCrudHint: "Ces données proviennent directement de la base via l'API.",
    price: "Prix",
    originalPrice: "Prix d'origine",
    stock: "Stock",
    category: "Catégorie",
    active: "Actif",
    inactive: "Inactif",
	    imageLarge: "Image grande",
	    imageSmall: "Image petite",
	    cropImage: "Recadrer l'image",
	    cropHint: "Faites glisser l'image pour la cadrer.",
	    cropZoom: "Zoom",
	    cropCancel: "Annuler",
	    cropApply: "Appliquer",
	    cropReset: "Réinitialiser",
	    cropLargeTitle: "Recadrer l'image grande",
	    cropSmallTitle: "Recadrer l'image petite",
	    cropCategoryTitle: "Recadrer l'image de catégorie",
	    imageLargeRequired: "Veuillez ajouter une image grande du produit.",
	    imageSmallRequired: "Veuillez ajouter une image petite du produit.",
	    categoryImageRequired: "Veuillez ajouter une image de catégorie.",
	    role: "Rôle",
	    publishedAt: "Date de publication",
	    optional: "Optionnel",
	    cart: "Panier",
    continueShopping: "Continuer les achats",
    clearCart: "Vider le panier",
    cartEmpty: "Votre panier est vide.",
    browseProducts: "Voir les produits",
    remove: "Retirer",
    summary: "Récapitulatif",
    items: "Articles",
    total: "Total",
    loginToCheckout: "Se connecter pour payer",
    checkout: "Payer",
    cartNote: "Votre panier sera sauvegardé sur votre compte après connexion.",
    noDescription: "Aucune description pour ce produit.",
    inStock: "En stock",
    outOfStock: "Rupture",
    goToCart: "Aller au panier",
    adminTitle: "Panneau d'administration",
    adminIntro: "Gérez l'application depuis cet espace.",
	    adminDashboard: "Tableau de bord",
	    adminCategories: "Gérer les catégories",
	    adminProducts: "Gérer les produits",
	    adminOrders: "Gérer les commandes",
	    adminSettings: "Paramètres",
	    dashboardTitle: "Tableau de bord",
	    dashboardIntro: "Vue d'ensemble de BeldiMarket",
	    orders: "Commandes",
	    totalOrders: "Total commandes",
	    ordersLast7Days: "Commandes (7 derniers jours)",
	    quickActions: "Actions rapides",
	    manageOrders: "Gérer les commandes",
	    adminOrdersIntro: "Suivre les commandes clients et changer leur statut.",
	    filterStatus: "Filtrer par statut",
	    refresh: "Actualiser",
	    all: "Toutes",
	    selectAll: "Tout sélectionner",
	    select: "Sélectionner",
	    exportExcel: "Exporter Excel",
	    comment: "Commentaire",
	    commentPlaceholder: "Ajouter un commentaire...",
	    orderId: "Commande",
	    client: "Client",
	    createdAt: "Créée le",
	    status: "Statut",
	    viewDetails: "Voir détails",
	    product: "Produit",
	    orderStatusOrdered: "Commandée",
	    orderStatusProcessing: "En traitement",
	    orderStatusShipped: "Expédiée",
	    orderStatusDelivered: "Livrée",
	    orderStatusCanceled: "Annulée",
	    adminStatsCategories: "Catégories",
	    adminStatsProducts: "Produits",
	    adminStatsOrders: "Commandes",
    adminStatsUsers: "Utilisateurs",
    adminManageProducts: "Gérer les produits",
    adminManageCategories: "Gérer les catégories",
    loginTitle: "Connexion admin",
    loginSubtitle:
      "Réservé aux comptes admin. Les opérations CRUD exigent un jeton valide.",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    loginBtn: "Se connecter",
    checkingSession: "Vérification de session...",
    clientLogin: "Connexion client",
    clientLoginTitle: "Connectez-vous à votre compte",
    clientLoginSubtitle: "Suivez vos commandes et recommandez plus vite.",
    clientRegister: "Créer un compte",
    clientRegisterTitle: "Créez votre compte client",
    clientRegisterSubtitle: "Sauvegardez favoris, commandes et paiements rapides.",
    registerBtn: "Créer le compte",
    haveAccount: "Déjà un compte ?",
    goLogin: "Se connecter",
    noAccount: "Pas de compte ?",
    goRegister: "Créer un compte",
    registerBtnShort: "S'inscrire",
    navHome: "Accueil",
    navBrand: "Notre marque",
    navAbout: "À propos",
    navProducts: "Produits",
    navBlog: "Blog",
    navContact: "Contact",
    categories: "Catégories",
    allCategories: "Tous les produits",
    subcategories: "Sous-catégories",
    allSubcategories: "Toutes",
    filters: "Filtres",
    min: "Min",
    max: "Max",
    resetFilters: "Réinitialiser",
    productsEmpty: "Aucun produit dans cette catégorie.",
    email: "Email",
    authEyebrow: "Compte",
    authLoginTab: "Connexion",
    authRegisterTab: "Créer un compte",
    authLoginTitle: "Se connecter",
    authLoginSubtitle: "Si votre compte est Admin, redirection automatique vers le dashboard admin.",
    authRegisterTitle: "Créer un compte client",
    authRegisterSubtitle: "Créez un compte pour sauvegarder vos commandes et acheter plus vite.",
    backToShop: "Retour à la boutique",
    authError: "Une erreur est survenue. Réessayez.",
    langAr: "العربية",
    langEn: "English",
    langFr: "Français",
  },
};
